const initDesktopMenuPopover = () => {
  const menuItems = document.querySelectorAll('.header__menu-item');

  menuItems.forEach(item => {
    const popover = item.querySelector('.header__submenu');
    if (popover) {
      item.addEventListener('mouseenter', () => {
        if (!popover.matches(':popover-open')) {
          popover.showPopover();
        }
      });

      item.addEventListener('mouseleave', () => {
        if (popover.matches(':popover-open')) {
          popover.hidePopover();
        }
      });
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDesktopMenuPopover);
} else {
  initDesktopMenuPopover();
}
